import { DeviceI, Size } from '../types/types'
import { isPointWithinBounds } from '../utils/chart'

export const useFloorPosition = (mapImageSize: Size) => {
  const validateMapPosition = (x: number, y: number): boolean => {
    const [imageWidth, imageHeight] = mapImageSize
    return isPointWithinBounds(x, y, 0, 0, imageWidth, imageHeight)
  }

  const validateDevicePosition = (deviceData: DeviceI): boolean => {
    return validateMapPosition(deviceData.x, deviceData.y)
  }

  return {
    validateDevicePosition,
    validateMapPosition,
  }
}
